import { create } from "zustand";
import i18next from "i18next";

export type NotificationStatus = "error" | "info" | "success";

export interface NotificationItem {
  id: string;
  status: NotificationStatus;
  message: string;
  timestamp: number;
}

export interface NotificationState {
  notifications: NotificationItem[];
  actions: {
    showNotification: (status: NotificationStatus, message: string) => void;
    notifyError: (translationKey: string) => string;
    hideNotification: (id: string) => void;
    clearAllNotifications: () => void;
  };
}

const useNotificationStore = create<NotificationState>((set, get) => ({
  notifications: [],
  actions: {
    showNotification: (status: NotificationStatus, message: string) => {
      const id = `notification-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
      const newNotification: NotificationItem = {
        id,
        status,
        message,
        timestamp: Date.now(),
      };
      
      set((state) => ({
        notifications: [...state.notifications, newNotification],
      }));
    },
    notifyError: (translationKey: string) => {
      const translatedMessage = String(i18next.t(translationKey));
      get().actions.showNotification("error", translatedMessage);
      return translatedMessage;
    },
    hideNotification: (id: string) => {
      set((state) => ({
        notifications: state.notifications.filter(notification => notification.id !== id),
      }));
    },
    clearAllNotifications: () => {
      set({ notifications: [] });
    },
  },
}));

export default useNotificationStore;
